// Ce fichier est le fichier d'inclusion des js depuis laravel 9.
require('./../_inte/js/main')

require('./components/Form/main')
require('./components/Pages/main')
require('./components/Utils/main')
